import { o } from './observable';
import { lang } from './page';
import { langMap } from './lang-map';

function identify(data) {
  const id = data.userId?.toLowerCase() || '';
  const org = data.org?.toLowerCase() || '';

  aptrinsic(
    'identify',
    {
      id,
      globalId: id,
      language: langMap[lang] ? langMap[lang] : lang,
      preferredLanguages: (data.preferred_languages || []).join(', '),
      entitlements: (data.entitlements || []).join(', '),
      interests: (data.interests || []).join(', '),
      roles: (data.role || []).join(', '),
      levels: (data.level || []).join(', '),
      activeOrg: org,
      emailOptIns: data.emailOptIn || false,
      emailVerified: data.emailVerified || false,
      mrktPerm: data.mrktPerm || '',
    },
    {
      id: org,
    },
  );
}

export function load() {
  o.once('auth', (data = null) => {
    if (data === null) {
      return;
    }

    (function (n, t, a, e, co) {
      const i = 'aptrinsic';
      n[i] =
        n[i] ||
        function () {
          (n[i].q = n[i].q || []).push(arguments);
        };
      n[i].p = e;
      n[i].c = co;
      const r = t.createElement('script');
      r.async = !0;
      r.onload = () => {
        identify(data);
      };
      r.src = `${a}?a=${e}`;
      const c = t.getElementsByTagName('script')[0];
      c.parentNode.insertBefore(r, c);
    })(window, document, 'https://web-sdk.aptrinsic.com/api/aptrinsic.js', 'AP-PCBATQJJQHRG-2');
  });
}
